import { get, isNil } from 'lodash';
import React, { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { unsetFocusedFieldProps } from '../../../actions/shortcuts';
import { editInformationField } from '../../../actions/take-off';
import { getCurrentSendedLeg } from '../../../selectors/sended-data';
import { useConvert } from '../../hooks/useMeasureConverter';
import { CustomPaletteForm } from '../../PaletteForm/CustomPaletteForm';
import { PaletteForm } from '../../PaletteForm/PaletteForm';
import { Panel } from '../../Panel/Panel.jsx';
import { TAKEOFF_FIELDS } from '../constants';

export const TakeOffPalette = memo(({ className }) => {
    const dispatch = useDispatch();
    const { t: translate } = useTranslation();
    const validationWeightFields = [
        { id: 'tow', type: 'number', validator: { type: 'int', min: 0, max: useConvert(560000) } },
        { id: 'mtow', type: 'number', validator: { type: 'int', min: 0, max: useConvert(560000) } },
    ];

    const { declaration, isCustomDeclarations, ...informationForm } = useSelector((state) => {
        const currentLeg = getCurrentSendedLeg(state);
        const takeOff = get(currentLeg, 'takeOff', {});
        const takeOffDeclaration = get(state, 'routesDeclaration.takeOffDeclaration', []);
        const isCustomDeclarations = get(state, 'routesDeclaration.isCustomDeclarations', false);

        // pilotFlight
        const result = {
            ...get(takeOff, 'informationForm', {}),
            declaration: takeOffDeclaration,
            isCustomDeclarations,
        };

        delete result.pilotFlight;

        return result;
    }, shallowEqual);

    const handleChangeField = React.useCallback((name, value) => {
        dispatch(editInformationField(name, !isNil(value) ? value : null));
    }, []);

    useEffect(() => () => dispatch(unsetFocusedFieldProps()), []);

    return (
        <>
            <Panel title={translate('labels.takeOffInfo')} className={className}>
                {isCustomDeclarations ? (
                    <CustomPaletteForm
                        onEditInformationField={handleChangeField}
                        informationForm={informationForm}
                        declaration={declaration}
                    />
                ) : (
                    <PaletteForm
                        onEditInformationField={handleChangeField}
                        informationForm={informationForm}
                        declaration={declaration}
                        fields={[...TAKEOFF_FIELDS, ...validationWeightFields]}
                    />
                )}
            </Panel>
        </>
    );
});
